export default __webpack_public_path__ + "static/media/smartphonePin.2b3f5716.svg";